import { render, staticRenderFns } from "./InspectRejectDetailQuery.vue?vue&type=template&id=ee4ca272"
import script from "./InspectRejectDetailQuery.vue?vue&type=script&lang=js"
export * from "./InspectRejectDetailQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports